import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { IJobAlertSettings } from '../interfaces/job-alert-settings';
import { Operation } from 'fast-json-patch';

@Injectable({ providedIn: 'root' })
export class JobAlertService extends BaseDataService {
  url = '/api/jobAlert';
  entityTitle = 'JobAlert';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public runAutoDirect(jobNumber: string, autoDirectSettingsId: number, preview: boolean) {
    return this.http
      .get(
        this.url +
          '/AutoDirect/' +
          jobNumber +
          '?preview=' +
          preview +
          '&autoDirectSettingId=' +
          autoDirectSettingsId,
      )
      .toPromise();
  }

  public generateJobAlertSettings(organisationId: number): Promise<any> {
    return this.http.get(this.url + '/generateSettings/' + organisationId).toPromise();
  }

  public createSetting(jobAlertSettingDTO: IJobAlertSettings) {
    return this.handleRequest(
      this.http.post(this.url + '/Setting', jobAlertSettingDTO),
      this.handlersFactory.getForCreate(this.entityTitle),
    ).then(this.extractData);
  }

  public patchSetting(jobAlertSettingId: number, patch: Operation[]) {
    return this.handleRequest(
      this.http.patch(this.url + '/Setting/' + jobAlertSettingId, patch),
      this.handlersFactory.getForUpdate(this.entityTitle),
    ).then(this.extractData);
  }

  public deleteSetting(jobAlertSettingId: number) {
    return this.http.delete(this.url + '/Setting/' + jobAlertSettingId).toPromise();
  }

  public getSetting(jobAlertSettingId: number): Promise<IJobAlertSettings> {
    console.log('GETTING ALERT SETTING ' + jobAlertSettingId);

    return this.http.get<IJobAlertSettings>(this.url + '/Setting/' + jobAlertSettingId).toPromise();
  }

  public getDefaultSettings() {
    return this.http.get<IJobAlertSettings>(this.url + '/DefaultSettings').toPromise();
  }

  public getSupplierSettings() {
    return this.http.get<IJobAlertSettings[]>(this.url + '/SupplierSettings').toPromise();
  }

  public generateSettings() {
    return this.http.get<any>(this.url + '/GenerateSettings').toPromise();
  }
}
